<template>
      <form>
		<v-row><v-col>
        <v-text-field outlined dense
					hide-details="auto"
          :disabled="loading"
          v-model="email"
          :label="$t('text.email')"
          :error-messages="emailErrors"
          required
          ref="email"
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
          @keyup.enter.native="login"
        ></v-text-field>
				</v-col></v-row>
				<v-row><v-col>

        <v-text-field outlined dense
					hide-details="auto"
          :disabled="loading"
          v-model="password"
          type="password"
          :label="$t('text.password')"
          :error-messages="passwordErrors"
          required
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
          @keyup.enter.native="login"
        ></v-text-field>
				</v-col></v-row>
				<v-row><v-col>

        <v-btn
          class="mr-4"
          :disabled="$v.$invalid || loading"
          @click="login"
        >{{ $t(`text.loginButton`) }}</v-btn>

        <v-btn
          class="mr-4"
          :disabled="loading"
          @click="forgotPassword"
        >{{ $t(`text.forgotPasswordButton`) }}</v-btn>
		</v-col><v-col align="right">

      
		</v-col></v-row>
		<spinner :loading="loading"></spinner>
      </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';

import authActions from '../store/actions/auth';
import rootActions from '../store/actions/root';
import namespace from '../store/namespace';

import Spinner from '../general/Spinner.vue';

import modelState from '../mixins/modelState';

export default {
	name: 'Login',
	mixins: [modelState],
	components: {
		Spinner,
	},
	validations: {
		email: {
			required,
			email,
		},
		password: {
			required,
		},
	},
	data() {
		return {
			email: '',
			password: '',
			loading: false,
		};
	},
	computed: {
		...mapGetters(namespace.AUTH, ['IsAuthenticated']),
		...mapGetters(namespace.USER, ['HasUser']),
		emailErrors() {
			const errors = [];

			if (!this.$v.email.$dirty) return errors;

			const apiErrors = this.validateProperty('Email');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.email.required
        && errors.push(this.$i18n.t('text.errorEmailRequired'));
			!this.$v.email.email
        && errors.push(this.$i18n.t('text.errorInvalidEmail'));

			return errors;
		},
		passwordErrors() {
			const errors = [];

			if (!this.$v.password.$dirty) return errors;

			const apiErrors = this.validateProperty('Password');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.password.required
        && errors.push(this.$i18n.t('text.errorPasswordRequired'));

			return errors;
		},
	},
	mounted() {
		this.LOGOUT();
	},
	methods: {
		...mapActions(namespace.AUTH, [authActions.LOGIN, authActions.LOGOUT]),
		...mapActions([rootActions.GET_ROOT_LINKS_AUTH]),
		async login() {
			this.loading = true;
			this.$v.$touch();

			if (!this.$v.$invalid) {
				try {
					this.modelState = {};
					await this.LOGIN(this);
					await this.GET_ROOT_LINKS_AUTH();									
					if (this.$route.name !== 'dashboard') this.$router.push('/dashboard');
				} catch (e) {
					if (e && e.response && e.response.status === 422) {
						this.modelState = e.response.data;
						if (this.modelError()) {
							throw new Error(this.modelError());
						}
					}

					throw e;
				} finally {
					this.loading = false;
				}
			}
			this.loading = false;
		},
		forgotPassword() {
			this.$router.push({
				name: 'forgotpassword',
				params: { cGuid: this.cGuid },
			});
		},
		register() {
			this.$router.push({
				name: 'register',
			});
		},
	},
};
</script>
